<template>
    <div class="messages">
        <button  @click.prevent="gotoPageLink()" class="button button--sec">{{ getUiString(['claim_details', 'claim', 'claim_lead_view_membership']) }}</button>
        <button  @click.prevent="confirmClose()" class="button button--sec">{{ getUiString(['claim_details', 'claim', 'claim_lead_already_member']) }}</button>
    </div>
    </template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ClaimLeadReactButton',
  props: {
    documentId: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      getUiString: 'uistrings/getUiString'
    })
  },
  methods: {
    confirmClose () {
      this.$store
        .dispatch('claim/confirmAction', { documentId: this.documentId })
        .then(() => {
          this.$store.dispatch('claim/refreshClaim')
        })
    },
    gotoPageLink () {
      window.open('https://www.consumentenbond.nl/wordlid/lidmaatschap?CID=euclaim_dossierclaim_cbwordlid', '_blank', 'noreferrer')
      this.confirmClose()
    }
  }
}
</script>
